import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";
import { dashboardReducer } from "./slices/dashboardSlice";
import { auditFormsReducer } from "./slices/auditFormsSlice";
import { auditsReducer } from "./slices/auditsSlice";
import { deletedAuditsReducer } from "./slices/deletedAuditsSlice";
import { clientEscalationsReducer } from "./slices/clientEscalationsSlice";
import { internalErrorRcaReducer } from "./slices/internalErrorRcaSlice";
import { processesReducer } from "./slices/processesSlice";
import { clientsReducer } from "./slices/clientsSlice";
import { departmentsReducer } from "./slices/departmentsSlice";
import { sendFormsReducer } from "./slices/sendFormsSlice";
import { feedbackRequestsReducer } from "./slices/feedbackRequestsSlice";
import { surveyReducer } from "./slices/surveySlice";
import { permissionsReducer } from "./slices/permissionsSlice";
import { rolesReducer } from "./slices/rolesSlice";
import { sectionsReducer } from "./slices/sectionsSlice";
import { usersReducer } from "./slices/usersSlice";
import { settingsReducer } from "./slices/settingsSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  qmsAuditForms: auditFormsReducer,
  qmsAudits: auditsReducer,
  qmsDeletedAudits: deletedAuditsReducer,
  qmsClientEscalations: clientEscalationsReducer,
  qmsInternalErrorRca: internalErrorRcaReducer,
  qmsProcesses: processesReducer,
  qmsClients: clientsReducer,
  qmsDepartments: departmentsReducer,
  vocSendForms: sendFormsReducer,
  vocFeedbackRequests: feedbackRequestsReducer,
  vocSurvey: surveyReducer,
  muPermissions: permissionsReducer,
  muRoles: rolesReducer,
  muSections: sectionsReducer,
  muUsers: usersReducer,
  settings: settingsReducer
});

export default rootReducer;
